export default __webpack_public_path__ + "assets/a6e8e16a05b07b090eb301d22ec636e7.svg";